export const FORBIDDEN = 5000;
/**
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const NOT_FOUND = 6000;
export const VALIDATION_ERROR = 7000;
export const MAINTENANCE = 9000;
// custom
// 問い合わせ 重複
export const BAD_INQUIRY_DUPLICATE = 3001;
// 問い合わせ 上限
export const BAD_INQUIRY_MAXIMUM = 3002;
// 組織が異なる
export const NOT_SAME_ORGANIZATION = 3100;
/**
 * 会員登録時の利用区分と許可ドメインが異なる（クライアント選択）
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_DIVISION_CLIENT = 3201;
/**
 * 会員登録時の利用区分と許可ドメインが異なる（コンサルタント選択）
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_DIVISION_PROFESSIONAL = 3202;
/**
 * 招待しようとしたユーザが削除済み
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_DELETED = 3301;
/**
 * 責任者を招待しようとしたが強制招待のフラグがない
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_ADMIN_NOT_HAS_FORCE_INVITE = 3302;
/**
 * 責任者の件数が異常
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_INVALID_ADMIN_SETTING = 3303;
// 自分が含まれていない
export const BAD_RFP_OFFER_MEMBER_NOT_EXIST_LOGIN_USER = 3304;
/**
 * メールアドレスが重複している
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_DUPLICATE_EMAIL = 3305;
/**
 * 招待しようとしたユーザがクライアントなどで招待できない
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_CANT_INVITE_USER = 3306;
/**
 * 提案済みのユーザーを招待しようとしていた
 * @deprecated TS化済 src/utils/constants/api/responseCode.ts
 */
export const BAD_RFP_OFFER_MEMBER_HAS_OTHER_OFFER = 3307;
// 提案を誰かが更新中
export const BAD_RFP_OFFER_UPDATING = 3311;
// 案件の募集期限を超過している
export const BAD_RFP_OFFER_OVER_RFP_DEADLINE = 3321;
// 質問の締切期限を超過している
export const BAD_RFP_OFFER_OVER_ONLINE_QUESTION_DEADLINE = 3322;
// 招待しようとしたユーザが削除済み
export const BAD_RFP_MEMBER_DELETED = 3331;
// 招待しようとしたユーザがコンサルタントなどで招待できない
export const BAD_RFP_MEMBER_CANT_INVITE_USER = 3332;
// 自分がグループの中に存在しない
export const BAD_PROFFIT_SEARCH_ACCOUNT_DOESNT_EXIST_USER = 3401;
// 招待できないユーザー
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_USER = 3402;
// 携帯端末からAPIを実行
export const BAD_PROFFIT_SEARCH_IS_DEVICE = 3403;
// 無効化済みのため招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_DISABLE_ACCOUNT = 3405;
// 組織が違うので招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_OTHER_ORGANIZATION = 3406;
// 管理者が退会済みなどで登録できない状態
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ACCOUNT = 3403;
// 管理者の組織が違うので招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_ORGANIZATION = 3407;
// 管理者がグループ参加済みの一般ユーザーなので招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_ROLE = 3408;
// 管理者のグループが違うので招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_OTHER_GROUP = 3409;
// 管理者が変更されていない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_ADMIN_SAME = 3413;
// 招待されたユーザーがトライアル登録済みでトライアル招待できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_INVITE_TRIAL = 3410;
// スライド共有相手が退会済みなどで共有できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_ACCOUNT = 3411;
// スライド共有相手の組織が違うので共有できない
export const BAD_PROFFIT_SEARCH_ACCOUNT_CANT_SHARE_SLIDE_OTHER_ORGANIZATION = 3412;
// 登録済みで使えないメールアドレス
export const BAD_REGISTRATION_INVALID_EMAIL = 3501;
// ログイン種別の認証エラー
export const UNAUTHORIZED_LOGIN_TYPE = 4001;
// slide参照権限なし
export const FORBIDDEN_SLIDE = 5001;
